import { NotificationBanner, Disclaimer } from 'entities/organization/model';

import {
  INIT,
  INIT_FAILED,
  SAVE_NOTIFICATION_BANNER,
  SAVE_DISCLAIMERS,
  SAVE_FORM,
} from './constants';

export interface InitAction {
  type: typeof INIT;
}
export const initAction = (): InitAction => ({
  type: INIT,
});

export const initFailedAction = (error: any) => ({
  type: INIT_FAILED,
  error,
});

export interface HomepageBannerData {
  homepageBanner: string;
  homepageTagline: string;
  hideHomepageTagline: boolean;
  homepageGradient: boolean;
}

export interface SplashImageData {
  splashBackgroundImage: string;
}

export interface FaqLinkData {
  faqLink: string;
}

export interface DisclaimersData {
  disclaimers: Disclaimer[];
}

export interface SaveFormAction {
  type: typeof SAVE_FORM;
  data: HomepageBannerData | FaqLinkData | SplashImageData;
}
export const saveFormAction = (
  data: HomepageBannerData | FaqLinkData | SplashImageData
): SaveFormAction => ({
  type: SAVE_FORM,
  data,
});

export interface SaveNotificationBannerAction {
  type: typeof SAVE_NOTIFICATION_BANNER;
  data: NotificationBanner;
}
export const saveNotificationBannerAction = (
  data: NotificationBanner
): SaveNotificationBannerAction => ({
  type: SAVE_NOTIFICATION_BANNER,
  data,
});

export interface SaveDisclaimersAction {
  type: typeof SAVE_DISCLAIMERS;
  data: { disclaimers: Disclaimer[] };
}
export const saveDisclaimersAction = (data: {
  disclaimers: Disclaimer[];
}): SaveDisclaimersAction => ({
  type: SAVE_DISCLAIMERS,
  data,
});
